import locale from "@/helpers/locale";
export const publishMapping = {
  "public": {
    className: "",
    content: locale('cinemaWebsite.news.table.header.showing'),
  },
  "draft": {
    className: "red",
    content: locale('mail.list.publishStatus.draft'),
  },
  "schedule": {
    className: "purple",
    content: locale('mail.list.publishStatus.prePublish'),
  },
};
export const publicTargetMapping = {
  "memberPage": "会員ページ",
  "email": "メール",
}